import * as React from 'react';
import { useLocalStorage } from '@grandvisionhq/lib-utils-w3c';
import { SHIPPING_STATE_KEY } from '../models/shippingTypes.js';
import { USER_DETAILS_STATE_KEY } from '../models/user-details-types.js';
import { LoggedInCheckoutStateContext } from './context.js';

const LoggedInExpressCheckoutProvider = ({ children ,  })=>{
    const [consents, updateConsents] = React.useState([]);
    const [storedShippingState, setShippingState] = useLocalStorage(SHIPPING_STATE_KEY, {
        store: null,
        pickupPoint: null,
        isPickupOrder: false,
        serviceStore: null,
        selectedShippingMethod: {
            method: undefined,
            isValid: false,
            isTouched: false
        },
        isAddressesEqual: true
    });
    const [storedUserDetailsState, setUserDetailsState] = useLocalStorage(USER_DETAILS_STATE_KEY, {
        billingAddress: undefined,
        contactDetails: undefined,
        invoiceDetails: undefined,
        companyDetails: undefined
    });
    const [isSaveToDetailsChecked, setIsSaveToDetailsChecked] = React.useState(false);
    const [isFailedToFetchUserData, setIsFailedToFetchUserData] = React.useState(false);
    const [acceptedOptIns, setAcceptedOptIns] = React.useState(undefined);
    const [isCompany, setIsCompany] = React.useState(false);
    const [isOrderDetailsValid, setisOrderDetailsValid] = React.useState(true);
    const [isOrderInProgress, setIsOrderInProgress] = React.useState(false);
    const [isUserLoggedIn, setIsUserLoggedIn] = React.useState(false);
    var _selectedShippingMethod;
    const value = React.useMemo(()=>({
            shippingState: storedShippingState,
            setShippingState,
            userDetailsState: storedUserDetailsState,
            setUserDetailsState,
            selectedShippingMethod: (_selectedShippingMethod = storedShippingState.selectedShippingMethod) !== null && _selectedShippingMethod !== void 0 ? _selectedShippingMethod : {
                method: undefined,
                isValid: false,
                isTouched: false
            },
            isCompanyOrder: isCompany,
            setIsCompany,
            isPickupOrder: storedShippingState.isPickupOrder,
            optIns: acceptedOptIns,
            consents,
            updateConsents,
            isSaveDetailsInAccount: isSaveToDetailsChecked,
            setOptIns: setAcceptedOptIns,
            setIsSaveDetailsInAccount: setIsSaveToDetailsChecked,
            isOrderDetailsValid,
            setisOrderDetailsValid,
            isOrderInProgress,
            setIsOrderInProgress,
            isAddressesEqual: storedShippingState.isAddressesEqual,
            isFailedToFetchUserData,
            setIsFailedToFetchUserData,
            isUserLoggedIn,
            setIsUserLoggedIn
        })
    , [
        storedShippingState,
        setShippingState,
        storedUserDetailsState,
        setUserDetailsState,
        isCompany,
        acceptedOptIns,
        consents,
        isSaveToDetailsChecked,
        isOrderDetailsValid,
        isOrderInProgress,
        isFailedToFetchUserData,
        isUserLoggedIn, 
    ]);
    return /*#__PURE__*/ React.createElement(LoggedInCheckoutStateContext.Provider, {
        value: value
    }, children);
};

export { LoggedInExpressCheckoutProvider };
//# sourceMappingURL=Provider.js.map
